import { FeaturedImageFragment } from '@/fragments/FeaturedImage'
import { gql } from '@apollo/client'

export const variables = ({ databaseId }, ctx) => {
  return {
    databaseId,
    asPreview: ctx?.asPreview
  }
}

export const query = gql`
  ${FeaturedImageFragment}
  query GetPageData($databaseId: ID!, $asPreview: Boolean = false) {
    page(id: $databaseId, idType: DATABASE_ID, asPreview: $asPreview) {
      title
      seo {
        metaDesc
        title
      }
      ...FeaturedImageFragment
      innerHeroFields {
        content
        eyebrowText
        fieldGroupName
        includeForm
        title
      }
    }
    posts(first: 12) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        date
        uri
        title
        excerpt
        categories {
          nodes {
            name
          }
        }
        ...FeaturedImageFragment
        postFields {
          blogSliderImage {
            node {
              sourceUrl
              altText
            }
          }
        }
      }
    }
    categories(first: 5) {
      nodes {
        name
      }
    }
  }
`
